import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LangContext";
import Reveal from "./Reveal";

export default function AiCrmSection() {
  const { t, link } = useLang();
  const steps = t("aicrm.steps");
  return (
    <section data-testid="ai-crm-section" className="bg-ink bg-grid-dark py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <p className="text-xs font-semibold tracking-[0.25em] text-electric">{t("aicrm.eyebrow")}</p>
          <h2 className="mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight max-w-3xl">{t("aicrm.title")}</h2>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="mt-12 flex flex-wrap items-stretch gap-y-4">
            {steps.map((s, i) => (
              <div key={s} className="flex items-center">
                <div className={`rounded-xl border px-4 py-3 ${i === steps.length - 1 ? "border-electric/50 bg-gradient-to-r from-dblue/20 to-electric/20" : "border-white/10 bg-white/5"}`}>
                  <p className="text-[9px] font-bold tracking-[0.2em] text-electric">{String(i + 1).padStart(2, "0")}</p>
                  <p className="mt-1 text-xs sm:text-sm font-semibold text-white/90">{s}</p>
                </div>
                {i < steps.length - 1 && <ArrowRight className="mx-2 h-4 w-4 text-electric/60 shrink-0" />}
              </div>
            ))}
          </div>
        </Reveal>
        <Reveal delay={0.25}>
          <p className="mt-10 max-w-3xl text-base sm:text-lg text-steel leading-relaxed">{t("aicrm.copy")}</p>
          <Link to={link("/ai-secretary")} data-testid="aicrm-cta" className="mt-8 inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-dblue to-electric px-7 py-3.5 text-sm font-semibold transition-transform duration-200 hover:scale-[1.04]">
            {t("aicrm.cta")} <ArrowRight className="h-4 w-4" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
